import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to top of page when route changes
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
